import { api } from "./api";
import { ProviderStatus } from "@/contexts/AuthContext";

export type ProviderProfile = {
  id: string;
  companyName: string;
  rfc: string | null;
  location: string | null;
  description: string | null;
  website: string | null;
  contactPhone: string | null;
  logoUrl: string | null;
  minAdvanceBookingDays: number;
  verified: boolean;
  status: ProviderStatus;
  email: string;
};

export type UpdateProviderProfileInput = {
  companyName: string;
  rfc?: string;
  location?: string;
  description?: string;
  website?: string;
  contactPhone?: string;
};

export function getProviderProfile(): Promise<ProviderProfile> {
  return api<ProviderProfile>("/provider/profile");
}

export function updateProviderProfile(input: UpdateProviderProfileInput): Promise<ProviderProfile> {
  return api<ProviderProfile>("/provider/profile", { method: "PUT", body: input });
}

export function updateBookingSettings(minAdvanceBookingDays: number): Promise<ProviderProfile> {
  return api<ProviderProfile>("/provider/profile/booking-settings", { method: "PUT", body: { minAdvanceBookingDays } });
}
